import moment from 'moment';
import {
  MY_FILTER,
  // 时间筛选器
  RANGE_TIME as FILTER_RANGE_TIME,

  // 单平台筛选器
  SINGLE_PLATFORM_SELECT as FILTER_SINGLE_PLATFORM_SELECT,
  SINGLE_PLATFORM_SELECT_EXTEND_TYPE,

  // 组合国家筛选器
  COMPOSED_COUNTRY_SELECT as FILTER_COMPOSED_COUNTRY_SELECT,
  COMPOSED_COUNTRY_SELECT_EXTEND_TYPE,
  REGION_CASCADER_SELECT as FILTER_REGION_CASCADER_SELECT,

  // 品类筛选器
  GENRETOR as FILTER_GENRE_SELECT,

  // Product Model筛选器
  SENSOR_TOWER_TAG_PRODUCT_MODEL,

  // 热门标签筛选器
  HOT_TAGS_SOURCE,
} from '@/pages/intelligence/components/Filter/FilterBase/_config';

export const MOBILE_STORE_RANK_COUNTRY_INHERIT_CHANGED = '__mobileStoreRankCountryInheritChanged';

const isValidDate = (date: moment.Moment) =>
  // 选择范围在今天之前
  date.isSameOrBefore(moment(), 'day');

// 筛选器默认配置
export const FILTER_DEFAULT_LIST_MAP = {
  MY_FILTER: {
    savePopupVisble: 0,
    key: MY_FILTER,
    style: { width: 140 },
    value: '',
  },
  FILTER_RANGE_TIME: {
    savePopupVisble: 1,
    key: FILTER_RANGE_TIME,
    type: FILTER_RANGE_TIME,
    visible: 1,
    disabled: false,
    disabledDate: isValidDate,
    calendarType: 'date',
    autoRange: {
      timeType: 'date',
      length: 0,
    },
    showSelectType: false,
    showShortcut: false,
  },
  FILTER_SINGLE_PLATFORM_SELECT: {
    savePopupVisble: 1,
    key: FILTER_SINGLE_PLATFORM_SELECT,
    type: FILTER_SINGLE_PLATFORM_SELECT,
    className: 'dbi-mobile-store-rank_single-platform-select',
    extendFilterType: SINGLE_PLATFORM_SELECT_EXTEND_TYPE.common,
    visible: 1,
    disabled: false,
    entityType: 'mobile',
    platforms: ['appstore', 'googleplay'],
  },
  FILTER_COMPOSED_COUNTRY_SELECT: {
    savePopupVisble: 1,
    key: FILTER_COMPOSED_COUNTRY_SELECT,
    type: FILTER_REGION_CASCADER_SELECT,
    className: 'dbi-mobile-store-rank_composed-country-select',
    extendFilterType: COMPOSED_COUNTRY_SELECT_EXTEND_TYPE.common,
    visible: 1,
    disabled: false,
    isShowTypeSelect: false,
    footer: null,
    options: [],
    title: 'dbi_region',
    placeholder: 'dbi_select_region',
  },
  FILTER_GENRE_SELECT: {
    savePopupVisble: 1,
    key: FILTER_GENRE_SELECT,
    className: 'hot-tags-genre-select',
  },
  FILTER_SENSOR_TOWER_TAG_PRODUCT_MODEL: {
    savePopupVisble: 1,
    key: SENSOR_TOWER_TAG_PRODUCT_MODEL,
    title: 'dbi_detail_product_model',
    default: {
      value: [],
    },
  },
  HOT_TAGS_SOURCE: {
    savePopupVisble: 1,
    key: HOT_TAGS_SOURCE,
    options: [],
  },
};

// 筛选器默认值
export const FILTER_DEFAULT_VALUE = {
  [MY_FILTER]: {
    value: '',
  },
  [FILTER_RANGE_TIME]: {
    type: 'date',
    value: [moment(), moment()],
  },
  [FILTER_SINGLE_PLATFORM_SELECT]: {
    value: 'appstore',
  },
  [FILTER_COMPOSED_COUNTRY_SELECT]: {
    value: {
      type: 'single',
      countries: ['us'],
    },
  },
  [FILTER_GENRE_SELECT]: {
    source: 'sensortower',
    mainGenres: [],
    subGenres: [],
    level3Genres: [],
    level4Genres: [],
  },
  [SENSOR_TOWER_TAG_PRODUCT_MODEL]: {
    value: [],
  },
};

// 筛选器默认配置
export const FILTER_DEFAULT_INPUT_LIST = [
  FILTER_DEFAULT_LIST_MAP.MY_FILTER,
  FILTER_DEFAULT_LIST_MAP.FILTER_RANGE_TIME,
  FILTER_DEFAULT_LIST_MAP.FILTER_SINGLE_PLATFORM_SELECT,
  FILTER_DEFAULT_LIST_MAP.FILTER_COMPOSED_COUNTRY_SELECT,
  // 隐藏 Hot Tags 筛选器入口，保留配置/注入逻辑便于后续恢复
  // FILTER_DEFAULT_LIST_MAP.HOT_TAGS_SOURCE,
  FILTER_DEFAULT_LIST_MAP.FILTER_GENRE_SELECT,
  FILTER_DEFAULT_LIST_MAP.FILTER_SENSOR_TOWER_TAG_PRODUCT_MODEL,
];
